<template>
  <div>
    <div class="hero text-white text-center">
      <div class="container _sm">
        <h1 class="mb-6">404</h1>
      </div>
    </div>

    <div class="section bg-white text-secondary text-center py-32">
      Stranica nije pronađena. Molim Vas vratite se korak <a href="#" @click="$router.go(-1)">nazad</a> ili otiđite na <router-link :to="{ name: 'home' }">naslovnicu</router-link>.
    </div>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped>
  a {
    color: #231f20;
    padding-bottom: 1px;
    border-bottom: 3px solid #88c86f;
    transition: all .3s ease-in-out;
  }

  a:hover {
    color: #88c86f;
  }
</style>
